const DEFAULT_STRATEGIZER_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://strategizer.loopino.ai'
    : 'https://dev-strategizer.loopino.ai';

const normalizeOrigin = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return null;
  try {
    const parsed = new URL(raw);
    return parsed.origin.replace(/\/+$/, '');
  } catch {
    return null;
  }
};

const resolvedOrigin =
  normalizeOrigin(process.env.REACT_APP_STRATEGIZER_URL) ||
  normalizeOrigin(DEFAULT_STRATEGIZER_URL);

export const STRATEGIZER_BASE_URL = resolvedOrigin || DEFAULT_STRATEGIZER_URL;
export const STRATEGIZER_ORIGIN = STRATEGIZER_BASE_URL;
export const STRATEGIZER_ALLOWED_ORIGINS = new Set([STRATEGIZER_ORIGIN]);
